<div class="c__header">
  <p class="is-body-s is-semi-bold c__order-number">
    {{ 'order.number.default' | translate }}{{ order.code }}
  </p>
  <div class="c__information">
    @if (order?.date) {
      <p class="is-caption c__order-date">
        {{ order.date }}
      </p>
    }
    @if (order?.totalPrice) {
      <p class="is-caption is-semi-bold c__order-total-price">
        {{ order.totalPrice }}
        <sd-converted-price class="is-block is-text-right" [price]="order.totalPrice" [sourceCurrencyIsocode]="order.total?.currencyIso" />
        @if (order?.isTaxesIncluded) {
          <span class="c__taxes-included is-caption">
            {{'product.taxesIncluded' | translate }}
          </span>
        }
      </p>
    }
    @if (order?.status) {
      <p class="is-caption is-semi-bold c__order-status {{order.status.value === statusEnum.success ? 'is-success' : 'is-error'}}">
        {{ order.status.name | translate }}
      </p>
    }
  </div>
</div>

<div class="c__details">
  <div class="c__product-list">
    <ul>
      @for (product of order?.products | slice: 0:maxProductDisplayed; track product) {
        <li>
          <sd-banner [media]="product"
            [isFit]="true"
            [hasAltText]="false"
            [imgRatio]="imageRatioEnum.r1_1"
          />
        </li>
      }
    </ul>

    @if (order?.products?.length > maxProductDisplayed) {
      <p class="is-caption c__other-products">
        +{{ (order.products.length - maxProductDisplayed) }}
        {{ ((order.products.length - maxProductDisplayed > 1) ? 'product.products' : 'product.product') | translate }}
      </p>
    }
  </div>

  @if (order.link) {
    <sd-link [link]="order.link"
      [isButton]="true"
      [customClass]="order?.products?.length > maxProductDisplayed ? 'has-other-product c__link' : 'c__link'"
    >
      <span>{{ order.link.linkName | translate }}</span>
    </sd-link>
  }
</div>
